import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import loginImg from "./loginimg.png"; // Assuming this is the Passion Framework image
import * as API from "../Endpoints/Endpoints";

const RegistrationPage = () => {
  const [membername, setmembername] = useState("");
  const [email, setemail] = useState("");
  const [refcode, setrefcode] = useState("");
  const [organizationname, setorganizationname] = useState("");
  const [password, setpassword] = useState("");
  const [retypepassword, setretypepassword] = useState("");
  const [dob, setdob] = useState("");
  const [gender, setgender] = useState("");
  const [policyAccepted, setPolicyAccepted] = useState(false);
  const [aiPolicyAccepted, setAiPolicyAccepted] = useState(false);
  const history = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!policyAccepted || !aiPolicyAccepted) {
      alert("Please select both checkboxes to proceed.");
      return;
    }
    if (password !== retypepassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const response = await fetch(API.REGISTER_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ membername, email, organizationname, password }),
      });
      if (response.ok) {
        alert("Registration successful");
        history("/verify-otp");
      } else {
        const data = await response.text();
        alert("Registration failed: " + data);
      }
    } catch (err) {
      console.error("Error:", err);
      alert("An error occurred");
    }
  };

  return (
    <div className="flex flex-col justify-center items-center min-h-screen py-10 px-4 md:px-0 bg-gray-100">
      <div className="flex w-full max-w-4xl bg-white rounded-lg shadow-lg p-8">
        {/* Registration Form Section */}
        <div className="w-2/3 pr-8">
          <h2 className="text-4xl font-bold mb-6 text-center">Registration</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label htmlFor="membername" className="block text-lg font-medium text-gray-700">
                Member Name
              </label>
              <input
                type="text"
                id="membername"
                name="membername"
                value={membername}
                onChange={(e) => setmembername(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="email" className="block text-lg font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setemail(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="organizationname" className="block text-lg font-medium text-gray-700">
                Organization Name
              </label>
              <input
                type="text"
                id="organizationname"
                name="organizationname"
                value={organizationname}
                onChange={(e) => setorganizationname(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="dob" className="block text-lg font-medium text-gray-700">
                Date Of Birth
              </label>
              <input
                type="date"
                id="dob"
                name="dob"
                value={dob}
                onChange={(e) => setdob(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="gender" className="block text-lg font-medium text-gray-700">
                Gender
              </label>
              <select
                id="gender"
                name="gender"
                value={gender}
                onChange={(e) => setgender(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-lg font-medium text-gray-700">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setpassword(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="retypepassword" className="block text-lg font-medium text-gray-700">
                Re-Type Password
              </label>
              <input
                type="password"
                id="retypepassword"
                name="retypepassword"
                value={retypepassword}
                onChange={(e) => setretypepassword(e.target.value)}
                className="mt-1 p-2 w-full border border-gray-300 rounded-md text-lg"
                required
              />
            </div>

            {/* Policy Checkboxes */}
            <div className="mb-4">
              <input
                type="checkbox"
                id="policyAccepted"
                checked={policyAccepted}
                onChange={() => setPolicyAccepted(!policyAccepted)}
                className="mr-2"
              />
              <label htmlFor="policyAccepted" className="text-lg text-gray-700">
                Policy Acceptance
              </label>
            </div>
            <div className="mb-6">
              <input
                type="checkbox"
                id="aiPolicyAccepted"
                checked={aiPolicyAccepted}
                onChange={() => setAiPolicyAccepted(!aiPolicyAccepted)}
                className="mr-2"
              />
              <label htmlFor="aiPolicyAccepted" className="text-lg text-gray-700">
                Read AI Policy Terms and Conditions
              </label>
            </div>

            <div className="mb-6">
              <button
                type="submit"
                className="w-full py-3 px-6 border border-transparent rounded-md shadow-sm text-white bg-[#e64a32] hover:bg-[#e64a32] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e64a32] text-lg"
              >
                Register
              </button>
            </div>
          </form>
        </div>

        {/* Image Section */}
        <div className="w-1/3 flex justify-center items-center">
          <img src={loginImg} alt="Passion Framework" className="w-3/4 rounded-lg shadow-lg" />
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-6 text-gray-600 text-center text-sm">
  © 2025 Passionit.com All rights reserved. |{" "}
  <a href="https://passionit.com/index.php/privacy-policy/" className="text-[#e64a32] hover:underline">
    Privacy Policy
  </a>{" "}
  |{" "}
  <a href="https://passionit.com/index.php/childrens-terms-and-conditions/" className="text-[#e64a32] hover:underline">
    Children’s Terms and Conditions
  </a>{" "}
  |{" "}
  <a href="/ai-policy" className="text-[#e64a32] hover:underline">
  AI Policy Terms and Conditions
</a>
</footer>
    </div>
  );
};

export default RegistrationPage;
